<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="n in 3" :key="`line_loader_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <v-row dense class="text-h4">PJSIP Transport</v-row>
      <v-form ref="form">
        <v-row dense class="mt-4">
          <v-col cols="4">
            <v-text-field
              dense
              outlined
              v-model="form.bindIP"
              label="Bind IP"
              :error-messages="bindIPErrors"
              @input="$v.form.bindIP.$touch()"
              @blur="$v.form.bindIP.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              outlined
              v-model="form.bindPort"
              label="Porta"
              type="number"
              :error-messages="bindPortErrors"
              @input="$v.form.bindPort.$touch()"
              @blur="$v.form.bindPort.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              outlined
              v-model="form.externalIP"
              label="IP Externo"
              :error-messages="externalIPErrors"
              @input="$v.form.externalIP.$touch()"
              @blur="$v.form.externalIP.$touch()"
            />
          </v-col>
        </v-row>

        <v-divider class="mx-2 mt-2 mb-6" />

        <v-row v-for="n in qtdLocalNet" :key="n" align="baseline" dense>
          <v-col cols="3">
            <v-text-field
              dense
              outlined
              label="Rede Local"
              :rules="[rules.required, rules.validIpAddress]"
              v-model="local_netIp[n - 1]"
            />
          </v-col>

          <v-col cols="3">
            <v-text-field
              dense
              outlined
              label="Máscara da Rede Local"
              :rules="[rules.required, rules.validIpAddress]"
              v-model="local_netMask[n - 1]"
            />
          </v-col>

          <v-col cols="2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small dark icon color="bluePcm" v-bind="attrs" v-on="on" @click="novaLocalNet">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Nova Regex</span>
            </v-tooltip>

            <v-tooltip top v-if="n - 1 !== 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small dark icon color="darkRed" v-bind="attrs" v-on="on" @click="removeLocalNet(n - 1)">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover Regex</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
      <div v-for="n in 4" :key="n + 100">
        <v-divider dark vertical />
      </div>
    </div>
    <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapGetters, mapActions } from 'vuex'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import { registerVuexModule } from '@/utils/vuexUtils'

import transportStore from '../_store'
import transportHttpService from '../_services/transportHttpService'
import { validateData, validateComputed } from '../_validates'

export default {
  components: { FixedButtons, Snackbar },
  mixins: [validationMixin],

  data: () => ({
    showSkeleton: true,
    snackbar: false,
    isAlreadyRegistered: false,
    text: '',
    form: {
      bindIP: '',
      bindPort: '',
      externalIP: '',
      local_net: [],
    },
    local_netIp: [],
    local_netMask: [],
    pararLoader: {
      parar: false,
    },
    qtdLocalNet: 1,
    rules: {
      required: value => !!value || 'Campo Obrigatório.',
      validIpAddress: value =>
        /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(value) || /^.$/.test(value) ||
        !value ||
        'Insira um valor de IP ou Máscara válido.',
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('pjsiptransportModulePABXStore', ['getPjsipTransport']),
  },

  async created() {

    registerVuexModule(this.$store, 'pjsiptransportModulePABXStore', transportStore)

    await this.buscarPjsipTransport()
    if (typeof this.getPjsipTransport === 'object') {
      this.isAlreadyRegistered = true

    this.local_netIp.splice(0)
    this.local_netMask.splice(0)

    this.form.bindIP = this.getPjsipTransport.bindIP
    this.form.bindPort = this.getPjsipTransport.bindPort
    this.form.externalIP = this.getPjsipTransport.externalIP

    this.qtdLocalNet = this.getPjsipTransport.local_net.length
    this.getPjsipTransport.local_net.forEach(localNet => {
      this.local_netIp.push(localNet.ip)
      this.local_netMask.push(localNet.mask)
    })
    }
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('pjsiptransportModulePABXStore', ['buscarPjsipTransport']),

    async salvar() {
      this.pararLoader.parar = false

      if (!this.$refs.form.validate()) {
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      for (let i = 0; i < this.local_netIp.length; i++) {
        this.form.local_net[i] = {}
        this.form.local_net[i].ip = this.local_netIp[i]
        this.form.local_net[i].mask = this.local_netMask[i]
      }
      try{
        if (!this.isAlreadyRegistered) {
          await transportHttpService.postPjsipTransport(this.form)
        } else {
          await transportHttpService.putPjsipTransport(this.form)
        }

        this.$router.back()
      } catch (error) {
        this.text = error.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }

      this.pararLoader.parar = true
    },

    cancelar() {
      this.$router.back()
    },

    novaLocalNet() {
      this.qtdLocalNet += 1
    },

    removeLocalNet(key) {
      this.qtdLocalNet -= 1
      this.local_netIp.splice(key, 1)
      this.local_netMask.splice(key, 1)
    },
  },
}
</script>
